import React, {Component} from "react"
import styled from "styled-components"

import tracking from "@irati-tracking/admin"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import mainTheme from "@irati/ui/src/global/theme"
import {H2} from "@irati/ui/src/Typography"
import {get} from "lodash"
import {walletBlueBadge, walletGreenBadge, walletRedBadge} from "@irati-web/wallet/src/images"
import {ReportType} from "@irati/types"
import AdminRewardReporting from "@irati-web/wallet/src/components/AdminReward/Reporting"

import RewardOrders from "../../../components/Reporting/RewardOrders/index"
import WalletCard from "../../../components/Reporting/WalletCard/index"

export const FlexItem = styled.div`
  width: 33%;
`

interface State {}

interface Props extends InjectIntl, WithAuth {}

class Individuals extends Component<Props, State> {

  componentDidMount = () => {
    tracking.analyticsPeople()
  }

  render() {
    const {formatMessage, auth} = this.props
    const {productPermissions, business} = auth
    const tenantName = business.businessName
    const canManageTenantWallet = get(productPermissions, "wallet.tenantWallet")
    const showRewardWallet = get(productPermissions, "wallet.rewardWallet")
    const showUserWallet = get(productPermissions, "wallet.users")

    return (
      <>
        <AdminRewardReporting />
        <H2 marginBottom={4} marginTop={5}>
          {canManageTenantWallet || showUserWallet && <FormattedMessage id="admin.analytics.people.title1" />}
        </H2>
        <Flex gap={mainTheme.spacing.two}>
          {canManageTenantWallet && (
            <>
              <FlexItem>
                <WalletCard
                  id="tenantWalletDownloadReport"
                  title={formatMessage({id: "admin.analytics.people.walletCard.tenant"}, {tenantName})}
                  walletType="TENANT"
                  badge={walletBlueBadge}
                  currencyColor={mainTheme.colors.perkbox.blue}
                  reportType={ReportType.TenantWallet}  />
              </FlexItem>
              {showRewardWallet && (
                <FlexItem>
                  <WalletCard
                    id="rewardWalletDownloadReport"
                    title={formatMessage({id: "admin.analytics.people.walletCard.reward"})}
                    walletType="MANAGER"
                    badge={walletGreenBadge}
                    currencyColor={mainTheme.colors.perkbox.greenBlue}
                    reportType={ReportType.RewardsWallet} />
                </FlexItem>
              )}
            </>
          )}
          {showUserWallet && (
            <FlexItem>
              <WalletCard
                id="peopleWalletDownloadReport"
                title={formatMessage({id: "admin.analytics.people.walletCard.people"})}
                walletType="USER"
                badge={walletRedBadge}
                currencyColor={mainTheme.colors.tertiary.o_400}
                reportType={ReportType.PeopleWallet} />
            </FlexItem>
          )}
        </Flex>
        <H2 marginBottom={4} marginTop={3}>
          <FormattedMessage id="admin.analytics.people.title2" />
        </H2>
        <RewardOrders isReceiptEnabled={false} />
      </>
    )
  }
}

export default injectIntl(withAuth(Individuals))
